__turbopack_context__.v({
  "emptyContainer": "EmptyTableState-module-scss-module__mt001G__emptyContainer",
  "emptyStateHeader": "EmptyTableState-module-scss-module__mt001G__emptyStateHeader",
  "emptyStateIconContainer": "EmptyTableState-module-scss-module__mt001G__emptyStateIconContainer",
  "emptyStateParagraph": "EmptyTableState-module-scss-module__mt001G__emptyStateParagraph",
});
